import {css} from "@emotion/react"

export const displayFlex = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;